import { TextValue } from '../_general';

export enum ResultTypeEnum {
    NONE = 0,
    R2 = 1,
    R3 = 2,
}

export const resultTypeText: { [key in ResultTypeEnum]: string } = {
    [ResultTypeEnum.NONE]: '',
    [ResultTypeEnum.R2]: '+/-',
    [ResultTypeEnum.R3]: '++/+-/--',
};

export const resultTypes: TextValue[] = [
    { text: resultTypeText[ResultTypeEnum.NONE], value: ResultTypeEnum.NONE },
    { text: resultTypeText[ResultTypeEnum.R2], value: ResultTypeEnum.R2 },
    { text: resultTypeText[ResultTypeEnum.R3], value: ResultTypeEnum.R3 },
];
